module.exports = __webpack_public_path__ + "static/media/select-down.a0db4aab.svg";